import { Component, Vue } from 'vue-property-decorator'
import { BFormInput } from 'bootstrap-vue'

@Component
export default class Focusable<T extends HTMLElement | BFormInput = HTMLElement> extends Vue {
	$refs!: {
		focusable: T
	}

	focus() {
		const element = this.$refs.focusable
		element && element.focus()
	}

	blur() {
		const element = this.$refs.focusable
		element && element.blur()
	}
}
